import React from 'react';
import { useOutletContext, Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { API_URL } from '../App';

export default function Home() {
  const { settings } = useOutletContext();
  
  const getImg = (url, fallback) => {
    if (!url) return fallback;
    if (url.startsWith('http')) return url;
    return `${API_URL}${url}`;
  };

  const images = [
    getImg(settings.gallery_image_1, "https://images.unsplash.com/photo-1666453814025-f7e8a01c1aa3?crop=entropy&cs=srgb&fm=jpg&q=85"),
    getImg(settings.gallery_image_2, "https://images.pexels.com/photos/20016138/pexels-photo-20016138.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"),
    getImg(settings.gallery_image_3, "https://images.unsplash.com/photo-1633424414664-c24a6d28086b?crop=entropy&cs=srgb&fm=jpg&q=85")
  ];

  const initialY20 = React.useMemo(() => ({ opacity: 0, y: 20 }), []);
  const animateY0 = React.useMemo(() => ({ opacity: 1, y: 0 }), []);
  const delay02 = React.useMemo(() => ({ delay: 0.2 }), []);
  const delay04 = React.useMemo(() => ({ delay: 0.4 }), []);

  return (
    <div className="pb-24">
      {/* Elegant Hero */}
      <section className="relative pt-24 pb-32 flex flex-col items-center justify-center text-center px-4 max-w-4xl mx-auto">
        {settings.logo_url && (
          <img src={`${settings.logo_url.startsWith('http') ? '' : API_URL}${settings.logo_url}`} alt="Logo" className="h-40 sm:h-56 w-auto object-contain mx-auto mb-8 drop-shadow-2xl" />
        )}
        <motion.h1 
          initial={initialY20}
          animate={animateY0}
          className="text-4xl sm:text-6xl font-bold font-serif text-slate-900 tracking-[0.2em] uppercase mb-8 leading-tight"
        >
          {settings.title}
        </motion.h1>
        <div className="w-24 h-1 bg-orange-600 mx-auto mb-8"></div>
        <motion.p 
          initial={initialY20}
          animate={animateY0}
          transition={delay02}
          className="text-lg sm:text-xl text-slate-700 font-sans font-semibold mb-12 max-w-2xl mx-auto leading-loose uppercase tracking-widest"
        >
          {settings.bio}
        </motion.p>
        <motion.div
          initial={initialY20}
          animate={animateY0}
          transition={delay04}
        >
          <Link to="/menu" className="inline-block rounded-sm bg-slate-900 text-[#FDF9F1] font-bold px-10 py-4 text-sm uppercase tracking-[0.2em] hover:bg-orange-600 transition-colors shadow-lg">
            Ver Nuestro Menú
          </Link>
        </motion.div>
      </section>

      {/* Gallery */}
      <section className="max-w-6xl mx-auto px-4 py-16">
        <h2 className="text-2xl sm:text-3xl font-serif text-slate-900 text-center mb-16 tracking-[0.2em] uppercase font-bold">Nuestra Presentación</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="col-span-1 md:col-span-2 row-span-2 relative overflow-hidden shadow-2xl h-[500px] md:h-auto border-[12px] border-white">
            <img src={images[0]} alt="Food 1" className="w-full h-full object-cover" />
          </div>
          <div className="relative overflow-hidden shadow-xl h-[300px] border-[8px] border-white">
            <img src={images[1]} alt="Food 2" className="w-full h-full object-cover" />
          </div>
          <div className="relative overflow-hidden shadow-xl h-[300px] border-[8px] border-white">
            <img src={images[2]} alt="Food 3" className="w-full h-full object-cover" />
          </div>
        </div>
      </section>
    </div>
  );
}
